

import React, { useEffect, useRef, useState } from "react";
import { Invoice_Format_Config, printConfiguration } from "./InvoiceLayout.config";

import { FormInputSectionComponent } from "../../Components/FormInputSectionComponent/FormInputSectionComponent";
import { replaceUnderscore } from "../../../CommonFunction/common";
import { updateSingleField } from "../../Components/FormInputSectionComponent/formUtils";

import { GrtPreferenceByFormKey } from "../../../Utils/AllPagesQuriesAndMutations";
import { useLazyQuery } from "@apollo/client";
import { useDispatch } from "react-redux";

function convertCopiesToNumbers(value) {
  switch (value) {
    case "One Copy":
      return 1;
    case "Two Copies":
      return 2;
    case "Three Copies":
      return 3;
    case "Four Copies":
      return 4;
    default:
      return 1;
  }
}

const SideLayoutPdf = ({ handlechangelayout, loading, Table_Key, setDefaultFormData, mainFormKey }) => {
  const Form_Key = "SideLayoutPdf";
  const formRef = useRef({});
  const [FormFields] = useState(Invoice_Format_Config(Table_Key));
  const dispatch = useDispatch();
  const [FormData, setFormdata] = useState({});


  const [formErrors, setFormErrors] = useState({
    layout: "Layout-1",
    copies: "One Copy",
    type: "print",
  });

  const [getDataByKey] = useLazyQuery(GrtPreferenceByFormKey, {
    variables: {
      Form_Key: mainFormKey,
    },
    fetchPolicy: "network-only",
  });

  // useEffect(() => {
  //   updateSingleField(formRef, "copies", "One Copy");
  //   updateSingleField(formRef, "type", "preview");
  // }, []);

  useEffect(() => {
    getDataByKey({
      variables: {
        Form_Key: mainFormKey,
      },
    })
      .then(({ data }) => {
        console.log(data?.User_Preferences_By_Form_Key?.printConfigurationData, "datattt");
        let defaultData = data?.User_Preferences_By_Form_Key?.printConfigurationData;
        dispatch({
          type: "StoreMasterData",
          payload: {
            formkey: Form_Key,
            data: { layout: defaultData?.Default_Layout },
          },
        });
        updateSingleField(formRef, "copies", defaultData?.Default_Copies);
        updateSingleField(formRef, "type", defaultData?.Default_Type);
        updateSingleField(formRef, "layout", defaultData?.Default_Layout?.Search_Value);
      })
      .catch((err) => {
        console.log("catch");
        updateSingleField(formRef, "copies", "One Copy");
        updateSingleField(formRef, "type", "preview");
      });
  }, []);

  const HanldeChangeonForm = (values) => {
    handlechangelayout({
      ...values,
      copies: convertCopiesToNumbers(values.copies),
    });
    setFormdata((prev) => ({
      ...prev,
      ...values,
    }));
    setDefaultFormData((prev) => ({
      ...prev,
      ...values,
    }));
  };

  const handleErrorsChange = (newErrors) => {
    setFormErrors((currentErrors) => ({
      ...currentErrors,
      ...newErrors,
    }));
  };

  return (
    <div className="formContainer">
      <div>
        {FormFields?.map((e, i) => (
          <div key={e.id || i} className="FormSectionParent">
            <div className="sectionHeadings">{replaceUnderscore(e.name)}</div>
            <div className="FormSection insidecontainer">
              <FormInputSectionComponent
                inputfields={e.fields}
                Type={e.name}
                onErrorsChange={handleErrorsChange}
                onhandleFormikChange={HanldeChangeonForm}
                formkey={Form_Key}
                formRef={formRef}
              />
            </div>
          </div>
        ))}
      </div>
      {/* {prefShow && (
        <InputFieldPreferences
          formKey={mainFormKey}
          prefConfig={printConfigFields}
          show={prefShow}
          setPrefShow={setPrefShow}
          formRef={formRef}
          // setFirstLoad={setFirstLoad}
          HanldeChangeonForm={HanldeChangeonForm}
          forFormValues={FormData}
        />
      )} */}
    </div>
  );
};

export default SideLayoutPdf;
